import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteProvincia,
  getProvinciaById,
  postProvincia,
  updateProvincia,
} from "../../../../api/provincia";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getCountries } from "../../../../api/country";
import { Autocomplete } from "@material-ui/lab";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyProvincia() {
  return {
    fullName: "",
    pais: "",
  };
}

export default function EditProvinciasPage() {
  const [province, setProvince] = useState(getEmptyProvincia());
  const [countries, setCountries] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const provinceId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getCountries()
      .then((res) => {
        setCountries(res.data);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get the countries.",
        });
        history.push("/provinces");
      });

    if (!provinceId) {
      disableLoadingData();
      return;
    }

    getProvinciaById(provinceId)
      .then((res) => {
        setProvince(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get the province.",
        });
        history.push("/provinces");
      });
  }, [provinceId, disableLoadingData, history]);

  function saveProvincia() {
    if (!provinceId) {
      postProvincia(province)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Province saved successfully.",
          });
          history.push("/provinces");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not saved the province.",
          });
        });
    } else {
      updateProvincia(provinceId, province)
        .then((res) => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes saved successfully.",
          });
          history.push("/provinces");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not saved the cahnges.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setProvince({ ...provinceId, [element]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Editar província"></CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <TextField
                label="Province name"
                value={province.fullName}
                onChange={handleChange("fullName")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-4">
              <Autocomplete
                id='Countries'
                options={countries}
                value={province.pais || null}
                getOptionLabel={(option) => option.name}
                onChange={(_, newValue) => {
                  setProvince({
                    ...province,
                    country: newValue,
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Country'
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>

        </CardBody>
      </Card>

      <Button
        onClick={() => history.push("/provinces")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>

      <Button
        onClick={() => saveProvincia()}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save province
      </Button>

      {provinceId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete province
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this province?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProvincia(provinceId)
                .then((res) => {
                  alertSuccess({
                    title: "Deleted!",
                    customMessage: "Province deleted successfully.",
                  });
                  history.push("/provinces");
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not deleted the province.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
